import { useState, useEffect } from 'react';
import { Subtopic } from '../types/topics';
import apiClient from '../api/client';

export const useSubtopics = (topicIds?: number[]) => {
  const [data, setData] = useState<Subtopic[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchSubtopics = async () => {
      if (!topicIds?.length) {
        setData([]);
        setIsLoading(false);
        return;
      }

      try {
        const allSubtopics: Subtopic[] = [];
        for (const topicId of topicIds) {
          const response = await apiClient.get(`/api/v1/topics/${topicId}/subtopics`);
          allSubtopics.push(...response.data.data);
        }
        setData(allSubtopics);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch subtopics'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubtopics();
  }, [topicIds]);

  return { data, isLoading, error };
};